import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { EmptyState } from "../../components/patterns";

const NotMade = () => {
  const navigate = useNavigate();

  return (
    <main className="portal-page">
      <EmptyState
        size="page"
        title="Page under construction"
        description="This section is not available yet."
        actions={
          <Button type="button" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Go back
          </Button>
        }
      />
    </main>
  );
};

export default NotMade;
